import { z } from 'zod';

import { DocumentSchema } from '@/modules/documents/domain/entities/document';

export namespace SiteMetadata {
  export namespace Value {
    export namespace StringValue {
      // Define allowed string formats
      export namespace Format {
        export const Schema = z.enum(['default', 'type']);
      }
      export type Format = z.infer<typeof Format.Schema>;

      export const Schema = z.object({
        type: z.literal('string'),
        format: Format.Schema.optional(),
        value: z.string(),
      });
    }

    export namespace NumberValue {
      export namespace Format {
        export const Schema = z.enum([
          'watt',
          'watt_hour',
          'volt',
          'ampere',
          'ampere_hour',
          'celsius',
          'percent',
          'year',
        ]);
      }
      export type Format = z.infer<typeof Format.Schema>;

      export const Schema = z.object({
        type: z.literal('number'),
        format: Format.Schema.optional(),
        value: z.number(),
      });
    }
    export namespace DateValue {
      export namespace Format {
        export const Schema = z.enum(['date', 'datetime']);
      }
      export type Format = z.infer<typeof Format.Schema>;

      export const Schema = z.object({
        type: z.literal('date'),
        format: Format.Schema,
        value: z.date(),
      });
    }

    export namespace CronValue {
      export const Schema = z.object({
        type: z.literal('cron'),
        value: z.string(),
      });
    }
    export namespace UnknownValue {
      export const Schema = z.object({
        type: z.literal('unknown'),
        value: z.unknown(),
      });
    }

    export const Schema = z.discriminatedUnion('type', [
      StringValue.Schema,
      NumberValue.Schema,
      DateValue.Schema,
      CronValue.Schema,
      UnknownValue.Schema,
    ]);
  }
  export type Value = z.infer<typeof Value.Schema>;

  export namespace Document {
    export const Schema = DocumentSchema.pick({
      id: true,
      name: true,
    });
  }
  export type Document = z.infer<typeof Document.Schema>;

  export namespace Row {
    export const Schema = z.object({
      // TODO: check if "key" is still the best name
      key: z.string(),
      value: Value.Schema,
      document: Document.Schema.optional(),
    });
  }
  export type Row = z.infer<typeof Row.Schema>;

  export namespace GroupRow {
    export const Schema = z.object({
      key: z.string(),
      rows: z.array(Row.Schema),
    });
  }
  export type GroupRow = z.infer<typeof GroupRow.Schema>;

  export namespace Section {
    export const Schema = z.object({
      // TODO: check if "key" is still the best name
      key: z.string(),
      groups: z.array(GroupRow.Schema),
    });
  }
  export type Section = z.infer<typeof Section.Schema>;
}
